<template>
    <div>
        <section class="section hero-section bg-ico-home-1 p-3" style="height: 150px;">
        </section>

        <!-- Features start -->
        <section class="section bg-white">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-lg-6 col-12">
                        <div data-aos="fade-right">
                            <img src="awan/images/object-1.webp" alt="jualan-pintar-makin-cuan" class="img-fluid mx-auto d-block">
                        </div>
                    </div>
                    <div class="col-lg-6 col-12 ml-auto">
                        <div class="mt-4 mt-md-auto">
                            <h1 class="text-center font-weight-bold mb-3 hero-title"  data-aos="fade-up"
                                style="font-family: 'Baloo Paaji'; color: #233dff">Jualan Pintar <br>Makin CUAN</h1>
                            <br>
                            <p class="font-size-16 text-center" data-aos="fade-left">AWAN menyediakan Aplikasi Kasir yang sesuai dengan
                                kebutuhan usaha kamu seperti usaha warung, toko, rumah makan, toko elektronik, salon
                                kecantikan dan usaha lainnya. AWAN juga dilengkapi fitur pembayaran tagihan bulanan atau
                                PPOB seperti Pembayaran PLN, PDAM, BPJS, Token Listrik, Pulsa dan kebutuhan digital
                                lainnya.</p>
                            <br>
                            <div class="mt-2 text-center">
                                <img src="awan/images/particle-object-1.svg" width="80" class="img-fluid mx-auto d-inline" data-aos="fade-left">
                                <img src="awan/images/particle-object-1.svg" width="80" class="img-fluid mx-auto d-inline" data-aos="fade-up">
                                <img src="awan/images/particle-object-1.svg" width="80" class="img-fluid mx-auto d-inline" data-aos="fade-right">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    </div>
</template>
<script>
export default {
    name: 'Harga',
    components: {
    },
    data() {
        return {
        }
    },
    methods: {
    },
    mounted() {
        document.title = 'Daftar Harga Produk PPOB Di Awanbisnis'
        this.$Progress.start()
        AOS.init({
            easing: 'ease-out-back',
            duration: 2000,
        });
        this.$Progress.finish()
    },
}
</script>